export default __webpack_public_path__ + "static/japanese-1-e5d6fbb9ca6752c4c33b511e6ed57f38.png";